const { createAction } = require('../helpers')

const {
  GET_GROUP_LIST,
  GET_GROUP_LIST_SUCCESS,
  GET_GROUP_LIST_ERROR,
  GET_GROUP_LIST_RESET,
  GET_GROUP,
  GET_GROUP_SUCCESS,
  GET_GROUP_ERROR,
  GET_GROUP_RESET,
  CREATE_GROUP,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  CREATE_GROUP_RESET,
  UPDATE_GROUP,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  UPDATE_GROUP_RESET,
  DELETE_GROUP,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  DELETE_GROUP_RESET,
} = require('./constants')

const getGroupList = ({ search, take, skip }) => createAction(GET_GROUP_LIST, { search, take, skip })
const getGroupListSuccess = data => createAction(GET_GROUP_LIST_SUCCESS, { data })
const getGroupListError = error => createAction(GET_GROUP_LIST_ERROR, { error })
const getGroupListReset = () => createAction(GET_GROUP_LIST_RESET)

const getGroup = id => createAction(GET_GROUP, { id })
const getGroupSuccess = data => createAction(GET_GROUP_SUCCESS, { data })
const getGroupError = error => createAction(GET_GROUP_ERROR, { error })
const getGroupReset = () => createAction(GET_GROUP_RESET)

const createGroup = groupData => createAction(CREATE_GROUP, { groupData })
const createGroupSuccess = data => createAction(CREATE_GROUP_SUCCESS, { data })
const createGroupError = error => createAction(CREATE_GROUP_ERROR, { error })
const createGroupReset = () => createAction(CREATE_GROUP_RESET)

const updateGroup = ({ id, groupData }) => createAction(UPDATE_GROUP, { id, groupData })
const updateGroupSuccess = data => createAction(UPDATE_GROUP_SUCCESS, { data })
const updateGroupError = error => createAction(UPDATE_GROUP_ERROR, { error })
const updateGroupReset = () => createAction(UPDATE_GROUP_RESET)

const deleteGroup = ({ id }) => createAction(DELETE_GROUP, { id })
const deleteGroupSuccess = data => createAction(DELETE_GROUP_SUCCESS, { data })
const deleteGroupError = error => createAction(DELETE_GROUP_ERROR, { error })
const deleteGroupReset = () => createAction(DELETE_GROUP_RESET)

module.exports = {
  getGroupList,
  getGroupListSuccess,
  getGroupListError,
  getGroupListReset,
  getGroup,
  getGroupSuccess,
  getGroupError,
  getGroupReset,
  createGroup,
  createGroupSuccess,
  createGroupError,
  createGroupReset,
  updateGroup,
  updateGroupSuccess,
  updateGroupError,
  updateGroupReset,
  deleteGroup,
  deleteGroupSuccess,
  deleteGroupError,
  deleteGroupReset,
}
